import Vue from 'vue'
import Router from 'vue-router'

import Main from '@/components/Main'
import Aicc from '@/components/Aicc'
import Contact from '@/components/Contact'
import ConversationalAi from '@/components/ConversationalAi'

import {ROUTE_NAME} from '@/constants/constants';

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Main,
      name: 'main'
    }, 
    {
      path: '/aicc',
      component: Aicc, 
      name: 'aicc'
    },
    {
      path: '/contact',
      component: Contact, 
      name: 'contact'
    },
    {
      path: '/conversationalAi',
      component: ConversationalAi, 
      name: 'conversationalAi'
    },
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js